import { TextField } from "@mui/material";
import React from "react";

const CustomTextField = ({
  label,
  value,
  onChange,
  inputProps,
  onKeyDown,
  autoFocus,
  multiline,
  rows,
  isBadge,
}) => {
  const isReadOnly = inputProps?.readOnly;
  return (
    <TextField
      autoFocus={autoFocus}
      multiline={multiline}
      label={label}
      variant="outlined"
      fullWidth
      value={value}
      onChange={onChange}
      margin="normal"
      inputProps={inputProps}
      onKeyDown={onKeyDown}
      rows={rows}
      sx={{
        margin: 0,
        "& .MuiOutlinedInput-root": {
          borderRadius: "6px",
          "& fieldset": {
            borderColor: "grey",
          },
          "&:hover fieldset": {
            borderColor: isReadOnly ? "grey" : "#142C5C",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#142C5C",
          },
        },
        "& .MuiInputLabel-root": {
          color: "grey",
        },
        "& input": {
          color: isReadOnly ? "grey" : "black",
          pointerEvents: isReadOnly && "none",
        },
        "& textArea": {
          color: isBadge ? "gray" : "black",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#142C5C",
        },
      }}
    />
  );
};

export default CustomTextField;
